import React from 'react';
import ContainerTemplate from '../../../widgets/template/Container';
import EquiposView from './EquiposView';
import * as ROUTES from '../../../router/Routes';

const EquiposModule = () => {
  return (
    <ContainerTemplate
      active={ROUTES.equipos}
      routes={[ROUTES.juegosDeportivos]}
    >
      <EquiposView />
    </ContainerTemplate>
  );
};

export default EquiposModule;
